export default "__VITE_ASSET__D0fXXG1A__"